/**
 * light_pollution_live — the artificial skyglow over the CAMERA, this frame (the night-sky realism wave, 2026-10-06).
 * One writer (`AtlasSkyglowModule`, RenderSub/3, ~4 Hz from the settlement sites and lib/light_pollution.ts); every
 * reader (the sky shader's domes and star visibility, the city-light carpets, the haze, the clouds' undersides, the
 * night ambient) takes the SAME numbers, so a town's light agrees across systems. globalThis-backed (one store even
 * when Vite serves two module instances). Pure data — no three.
 */
import type { LightDome, LightSource, Skyglow } from './light_pollution.js';
import { GLOW_TINT, NATURAL_SQM, nelmFromSqm } from './light_pollution.js';

export interface SkyglowLive {
  /** The glow over the camera (zenith ratio, SQM, Bortle, NELM, tint). */
  glow: Skyglow;
  /** The K (4) strongest domes over the camera, strongest first. */
  domes: LightDome[];
  /** Every light source in the current world (empty outside the Commons). */
  sources: LightSource[];
  /** Absolute camera XZ the numbers were computed at. */
  x: number; z: number;
  /** performance.now() of the last update; 0 = never. */
  at: number;
  /** Whether the current world has artificial light (the Commons). */
  active: boolean;
}

const KEY = '__atlasSkyglowLive';
const g = globalThis as unknown as Record<string, SkyglowLive | undefined>;
export function skyglowLive(): SkyglowLive {
  let s = g[KEY];
  if (!s) {
    s = g[KEY] = {
      glow: { ratio: 0, sqm: NATURAL_SQM, bortle: 1, nelm: nelmFromSqm(NATURAL_SQM), tint: [...GLOW_TINT] },
      domes: [], sources: [], x: 0, z: 0, at: 0, active: false,
    };
  }
  return s;
}
export function setSkyglowLive(next: Omit<SkyglowLive, 'at'>): void {
  Object.assign(skyglowLive(), next, { at: performance.now() });
}
